<template>
  <v-app>
    <rec-header></rec-header>

    <v-main>
      <router-view> </router-view>
      <div class="sticky">
        <Sticky v-if="shouldShowModal">
          <i-btn fab @click="openModal">
            <v-badge
              overlap
              bordered
              :value="false"
              color="#2196f3"
              offset-x="12"
              offset-y="12"
            >
              <v-icon color="#757575">mdi-comment-processing</v-icon>
            </v-badge>
          </i-btn>
        </Sticky>
        <div v-if="isModalOpen" class="modal-wrapper">
          <div class="modal-content">
            <div style="text-align: right; margin-right: 15px; ">
              <button @click="closeModal" class="mdi mdi-close"></button>
            </div>
            <ModalViewVue v-if="isModalOpen" @close-modal="closeModal">
              <iframe
                width="100%"
                height="735px"
                :src="modalURL"
                frameborder="0"
              ></iframe>
            </ModalViewVue>
          </div>
        </div>
      </div>
    </v-main>

    <rec-footer></rec-footer>
  </v-app>
</template>

<script>
import RecHeader from '@/components/common/RecHeader';
import RecFooter from '@/components/common/RecFooter.vue';
import Sticky from '@/components/common/Sticky.vue';
import ModalViewVue from '@/components/ModalView.vue';

export default {
  name: 'App',
  components: {
    'rec-header': RecHeader,
    'rec-footer': RecFooter,
    Sticky,
    ModalViewVue,
  },

  data() {
    return {
      isModalOpen: false,
      modalURL:
        'https://hrchat.workup.plus/workup-aiagent-chatbot-admin/recruitModelTest',
    };
  },

  computed: {
    shouldShowModal() {
      // 페이지 URL에 "harim"이라는 문자열이 포함되어 있는지 확인합니다.
      return window.location.href.includes('harim');
    },
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
  },
};
</script>

<style scoped>
.modal-wrapper {
  position: fixed;

  margin-top: 0;
  margin-bottom: 0;

  bottom: 90px;
  right: 0;
  width: 20%; /* 모달의 너비 설정 */

  background-color: white;
  border: 1px solid #ccc;
  z-index: 1000;
}
.sticky {
  position: fixed;
  top: 75%;
  right: 40%;
  opacity: 1;
  margin: 0 -580px 0 0;
  transition: opacity 0.3s;
  &:hover {
    opacity: 1;
  }
}

.modal-content {
}

/* iframe {
  width: 100%;
  height: 100%;
  border: none;
} */
</style>
